var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgManuIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 881.2 881.2",
    style: {
      enableBackground: "new 0 0 881.2 881.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#C70300;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 440.8,
    cy: 440.4,
    r: 440.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M52.9,341.5h50.9l53.7,131h2.3l53.7-131h50.9v195h-40V409.6h-1.6l-50.5,126H145L94.5,409.1h-1.6v127.4h-40 V341.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M322.2,536.5H278l67.3-195h53.1l67.2,195h-44.2l-48.9-150.5h-1.5L322.2,536.5z M319.4,459.9h104.4v32.2H319.4 V459.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M642.6,341.5v195H607l-84.9-122.8h-1.4v122.8h-41.2v-195h36.2l84.2,122.7h1.7V341.5H642.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M787.4,341.5h41.2v126.7c0,14.2-3.4,26.7-10.1,37.3c-6.8,10.7-16.2,19-28.3,24.9c-12.1,5.9-26.3,8.9-42.4,8.9 c-16.2,0-30.3-3-42.5-8.9c-12.1-5.9-21.6-14.2-28.3-24.9c-6.7-10.7-10.1-23.1-10.1-37.3V341.5h41.2v123.1c0,7.4,1.6,14,4.9,19.8 c3.3,5.8,7.9,10.3,13.9,13.6c6,3.3,12.9,5,20.9,5c8,0,15-1.7,20.9-5c5.9-3.3,10.5-7.8,13.8-13.6c3.3-5.8,4.9-12.4,4.9-19.8V341.5z "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManuIcon);
export default __webpack_public_path__ + "static/media/manu_icon.bd8bcd960ae1d9b6743cb15ee974373d.svg";
export { ForwardRef as ReactComponent };